module.exports = __webpack_public_path__ + "static/media/480.a082c27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-spring/dark/480.png
// module id = 2462
// module chunks = 2